import React from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import fr from 'facet-rest';

const OutflowsMoneyFlowsHidden = ({ collection }) => {
  return (
    <FDBox>
      {collection.resources().list().map((moneyFlowResource) => (moneyFlowResource.relationship(fr.relationships.image.name) ? (
        <Box style={{
          backgroundImage: `url('${moneyFlowResource.relationship(fr.relationships.image.name)?.link('related').url()}')`,
          height: '0px',
          width: '0px',
        }}
        />
      ) : null))}
    </FDBox>
  );
};

OutflowsMoneyFlowsHidden.propTypes = {
  collection: PropTypes.object.isRequired,
};

OutflowsMoneyFlowsHidden.defaultProps = {};

export default OutflowsMoneyFlowsHidden;
